import {
  Component,
  ContentChildren,
  QueryList,
  Output,
  EventEmitter,
  AfterContentInit,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TabComponent } from './components/tab/tab.component';

@Component({
  selector: 'app-tabs',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements AfterContentInit {
  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
  @Output() tabChange = new EventEmitter<number>();

  @Input() activeIndex = 0;

  ngAfterContentInit(): void {
    if (this.tabs.length > 0 && this.tabs.toArray()[this.activeIndex]?.disabled) {
      const firstEnabled = this.tabs.toArray().findIndex((t) => !t.disabled);
      if (firstEnabled >= 0) {
        this.activeIndex = firstEnabled;
      }
    }
  }

  get isRouterMode(): boolean {
    return this.tabs?.some((tab) => tab.routerLink != null) ?? false;
  }

  trackByTab(_index: number, tab: TabComponent): string {
    if (Array.isArray(tab.routerLink)) {
      return tab.routerLink.join('/') || tab.label;
    }

    return String(tab.routerLink ?? tab.label);
  }

  selectTab(index: number): void {
    const tab = this.tabs.toArray()[index];
    if (tab && !tab.disabled) {
      this.activeIndex = index;
      this.tabChange.emit(index);
    }
  }
}
